module.exports = __webpack_public_path__ + "img/7.f671c9d2.jpg";